import Place from '@mui/icons-material/Place';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PlaceIcon(props: FixMe) {
  return <Place {...props} />;
}

export default PlaceIcon;
